import clsx from 'clsx';

import type { ButtonProps } from './Button';
import s from './ButtonPill.module.scss';

const ButtonPill = ({ type = 'button', className, ...props }: ButtonProps) => (
  <button type={type} className={clsx(s.pill, className)} {...props} />
);

export default ButtonPill;
